import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Permission } from '../../../utils/helpers/permissions';
import PermissionGate from '../../../utils/hooks/PermissionGate';
import { UploadFile } from './ContextSection/upload_file';
import { TopicQuestionGenerate } from './TopicSection/index';

export const QuestionGenerate = () => {
  const [activeTab, setActiveTab] = useState<number>(0);
  const tabTitles = [{ label: 'Context Based' }, { label: 'Topic Based' }];

  const renderTabContent = () => {
    if (activeTab === 0) {
      return <UploadFile />;
    } else if (activeTab === 1) {
      return <TopicQuestionGenerate />;
    }
  };

  return (
    <div className='space-y-3'>
      { /* Breadcrumb */ }
      <nav
          className='flex w-full flex-col gap-2 border-b border-slate-200 py-2 text-sm lg:flex-row lg:items-center lg:justify-between'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center gap-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              Questions
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-main font-semibold hover:underline'
            >
              Auto Generate Questions
            </Link>
          </li>
        </ol>
        <div className='flex flex-wrap gap-2 text-xs font-semibold sm:text-sm'>
          <PermissionGate
              requiredPermissions={[Permission.QUESTIONS_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-primary-main hover:bg-emerald-50'
                to={'/question-bank'}
            >
              Question Bank
            </Link>
          </PermissionGate>
          <PermissionGate
              requiredPermissions={[Permission.QUESTIONS_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-primary-main hover:bg-emerald-50'
                to={'/pre-screen-bank'}
            >
              Pre Screen Question Bank
            </Link>
          </PermissionGate>
          <PermissionGate
              requiredPermissions={[Permission.JOB_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-primary-main hover:bg-emerald-50'
                to={'/content-manager'}
            >
              Content Manager
            </Link>
          </PermissionGate>
        </div>
      </nav>

      { /* Tabs */ }
      <div className='rounded-lg border border-slate-200 bg-white p-1 shadow-sm'>
        <div className='grid w-full grid-cols-2 gap-1 sm:flex sm:w-auto'>
          { tabTitles.map(({ label }, i) => (
            <button
                key={label}
                type='button'
                className={`rounded-md px-3 py-2 text-sm font-bold transition ${
                  activeTab === i
                    ? 'bg-white text-emerald-700 shadow-sm ring-1 ring-slate-200'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                }`}
                onClick={() => setActiveTab(i)}
            >
              { label }
            </button>
          )) }
        </div>
      </div>

      { /* Tab Content */ }
      <div>{ renderTabContent() }</div>
    </div>
  );
};
